module.exports = __webpack_public_path__ + "img/slide02.e6611c09.jpg";